import { createElement } from 'react';
import { useReactDndConstructs as useDragAndDropHooks } from '../../../dnd/ReactDndContext';
import { TokenDragType } from '../../TokenInput';
import { TestIdProps } from '../../../util/testId';
import { TokenDesign } from '../TokenDesign';
import { TokenDesignProps } from '../types';
import { DragPreview } from '../../../dnd/view/DragPreview';
import cn from './TokenDragPreview.css.json';
import './TokenDragPreview.css';

export interface TokenDragPreviewProps extends TestIdProps {
  getTokenProps: (tokenIndex: number) => TokenDesignProps | null;
  dndPrefix: string;
}

export const TokenDragPreview = (props: TokenDragPreviewProps) => {
  const { useDragLayer } = useDragAndDropHooks();

  const { itemType, item } = useDragLayer((monitor) => ({
    itemType: monitor.getItemType(),
    item: monitor.getItem(),
  }));

  const renderItem = () => {
    if (!item || item.dndPrefix !== props.dndPrefix) return null;

    switch (itemType) {
      case TokenDragType:
        const tokenProps = props.getTokenProps(item.index);
        return tokenProps ? (
          <TokenDesign {...tokenProps} className={cn.token} tabIndex={-1} />
        ) : null;
      default:
        return null;
    }
  };

  return <DragPreview className={cn.dragImagePreview}>{renderItem()}</DragPreview>;
};
